<template>
  <div class="open-app" v-if="!isApp">
    <div class="h5-btn" @click="bindClick"></div>
    <wx-open-launch-app
      v-if="openApp.isWx"
      class="launch-btn"
      :class="{ hide: !openApp.isSign }"
      id="launch-btn"
      :appid="appId"
      :extinfo="extinfo"
      @error="handleErrorFn"
      @launch="handleLaunchFn"
    >
      <script type="text/wxtag-template">
        <style>.wx-open-launch-app-inner-container { position: absolute; width: 100%; height: 100%; opacity: 0; z-index: 1}</style>
        <div class="wx-open-launch-app-inner-container"></div>
      </script>
    </wx-open-launch-app>
  </div>
</template>
<script>
import openApp from './control'
export default {
  props: {
    //跳转应用的appid
    appId: {
      type: String,
      default: 'wxd35adf2e05f5e098'
    },
    extinfo: {
      type: String,
      default: '/home?pageTag=2'
    },
    sfrom: {
      type: String,
      default: 'JM_gongzhonghao'
    },
    //业务类型：betterwe 默认（原有行为）；zxg 综训馆（下载兜底页跳综训馆下载页）
    type: {
      type: String,
      default: 'betterwe'
    }
  },
  data() {
    return {
      openApp
    }
  },
  computed: {
    isZxg() {
      return this.type === 'zxg'
    }
  },
  created() {
    this.isApp = this.$http._isApp()
  },
  mounted() {},
  methods: {
    bindClick() {
      console.log('h5-btn-click')
      if (this.openApp.isWx) {
        this.jumpDownload()
      } else {
        location.href =
          'betterwe://deepLink/main?newPath=' +
          encodeURIComponent('/web?url=' + encodeURIComponent(location.href))
      }
    },
    jumpDownload() {
      //下载兜底：综训馆跳综训馆下载页，其余跳通用下载页（当前域名下路由，自动匹配环境）
      let url = this.isZxg ? '/zxg-scan-entry' : '/app-download'
      if (this.$route.query.sfrom == 'question') {
        url += '?sfrom=question'
      } else {
        url += '?sfrom=' + this.sfrom
      }
      location.href = url
    },
    handleErrorFn(e) {
      console.log('跳转失败', JSON.stringify(e))
      this.jumpDownload()
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      console.log('跳转成功', JSON.stringify(e))
    },
    // 判断是否微信环境
    isWeixn() {
      let ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        console.log('是微信')
        this.isWx = true
      } else {
        console.log('不是微信')
        this.isWx = false
      }
    },
    authSDK() {
      this.$http
        .getWxConfig()
        .then((res) => {
          res = res.data
          let data = res.data
          if (res.code == 200) {
            document.addEventListener('WeixinOpenTagsError', function (e) {
              console.error(e.detail.errMsg) // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
            })
            wxApi.config(
              data,
              ['onMenuShareTimeline', 'wx-open-launch-app'],
              ['wx-open-launch-app']
            )
            wx.error(function (res) {
              console.log(JSON.stringify(res))
              // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名
            })
            wx.ready(() => {
              this.isSign = true
            })
          }
        })
        .finally(() => {
          /* this.$nextTick(() => {
                  this.addEvent();
                }); */
        })
    },
    addEvent() {
      if (this.isWx) {
        this.$nextTick(() => {
          var btn = document.getElementById('launch-btn')
          btn.addEventListener('launch', (e) => {
            console.log('success')
          })
          btn.addEventListener('error', (e) => {
            console.log('fail', e.detail)
          })
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.open-app {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 9999;
}

.not-wx {
  width: 100%;
  height: 100%;
}

.launch-btn {
  user-select: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  left: 0;
  top: 0;
}
.h5-btn {
  user-select: none;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
}
.hide {
  width: 0;
  height: 0;
}

.ad-open {
  width: 100%;
  position: absolute;
  top: 0;
  right: 1vw;
}
</style>
